var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show && _vm.coupons.length > 0
    ? _c("div", { staticClass: "coupon-showcase" }, [
        _c(
          "div",
          { staticClass: "coupon-slider" },
          _vm._l(_vm.coupons, function (coupon, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "coupon-card",
                class: { selected: _vm.selectedIndex === index },
                on: {
                  click: function ($event) {
                    return _vm.handleClick(coupon, index)
                  },
                },
              },
              [
                _vm.getCouponTag(coupon)
                  ? _c(
                      "div",
                      { class: ["coupon-tag", _vm.getCouponTagColor(coupon)] },
                      [
                        _vm._v(
                          "\n\t\t\t\t" +
                            _vm._s(_vm.getCouponTag(coupon)) +
                            "\n\t\t\t"
                        ),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "coupon-check",
                    class: [
                      { checked: _vm.selectedIndex === index },
                      _vm.getCouponCheckDisabled(coupon),
                    ],
                  },
                  [_c("i", { staticClass: "fa fa-check" })]
                ),
                _c("div", { staticClass: "coupon-content" }, [
                  _c("div", { staticClass: "coupon-left" }, [
                    _c("div", { staticClass: "coupon-discount" }, [
                      _c("div", { staticClass: "discount-number" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" +
                            _vm._s(coupon.discountValue * 100 || 0)
                        ),
                        _c("span", { staticClass: "discount-unit" }, [
                          _vm._v("%"),
                        ]),
                      ]),
                      _c("span", { staticClass: "discount-label" }, [
                        _vm._v(_vm._s(_vm.$t("coupon.discount_label"))),
                      ]),
                    ]),
                    _c("div", { staticClass: "coupon-info" }, [
                      _c("div", {
                        staticClass: "coupon-title",
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("coupon.title_html")),
                        },
                      }),
                      coupon.limitedState === 1
                        ? _c("div", { staticClass: "coupon-title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("couponLottery.limit_use", {
                                  amount: "$49.99",
                                })
                              )
                            ),
                          ])
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "coupon-time" },
                        [
                          _vm.isExpired(coupon)
                            ? [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("coupon.expired_text"))),
                                ]),
                              ]
                            : _vm.isUsed(coupon)
                            ? [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("coupon.used_text"))),
                                ]),
                              ]
                            : [
                                _c("i", { staticClass: "fa fa-clock-o" }),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("coupon.countdown_prefix")) +
                                      " " +
                                      _vm._s(
                                        _vm.getCountdown(coupon.remainingTime)
                                      )
                                  ),
                                ]),
                              ],
                        ],
                        2
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "coupon-right" }),
                ]),
              ]
            )
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }